<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { getWeChatLoginUrl } from './util'
import { fetchPublicConfig, fetchWxUser, fetchRoleCodeList } from './services/UserService'

export default {
  name: 'App',
  async created() {
    await this.onSetPublicConfig()
    const openId = localStorage.getItem('openId')
    if (!openId) {
      if (this.$route.query.code) {
        const { code, state } = this.$route.query
        const response = await fetchWxUser({
          weCode: code,
          inviteCode: state === 'STATE' ? undefined : encodeURIComponent(state)
        })
        localStorage.setItem('openId', response.data.openId)
        localStorage.setItem('username', response.data.nickname)
        const roleCodeList = response.data.roleCodeList || []
        this.setRoleCodeList(roleCodeList)
      } else {
        const { inviteCode } = this.$route.query
        const { host, pathname } = window.location

        window.location.href = getWeChatLoginUrl(inviteCode || undefined, `https://${host}${pathname}`)
      }
    } else {
      const response = await fetchRoleCodeList({ openId })
      const roleCodeList = response.data || []
      this.setRoleCodeList(roleCodeList)
    }
  },
  methods: {
    ...mapMutations(['setPartnerName', 'setRoleCodeList', 'setAchievementRate', 'setCapacityPerCustomerTarget']),
    async onSetPublicConfig() {
      const config = await fetchPublicConfig({
        domain: 'https://admin.sparknt.cn'
      })
      const { partnerName, achievementRate, capacityPerCustomerTarget, wxAppId, h5Domain } = config.data.pubConfig || {}
      this.setPartnerName(partnerName)
      this.setAchievementRate(achievementRate)
      this.setCapacityPerCustomerTarget(capacityPerCustomerTarget)
      localStorage.setItem('AppId', wxAppId)
      if (h5Domain.includes('http')) {
        localStorage.setItem('DomainName', `${h5Domain}`)
      } else {
        localStorage.setItem('DomainName', `https://${h5Domain}`)
      }
    }
  }
}
</script>
<style lang="less">
#app {
  color: #2c3e50;
  height: 100%;
  font-size: 25px;
  line-height: 1.5;

  .tab-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;

    .custom-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      flex: 1;

      .text {
        font-size: 20px;
      }
    }
  }
}
</style>
